<template>
  <div>
    <app-collapse accordion>
      <app-collapse-item
        class="border rounded my-1"
        title="اليوم العالمي للسكان"
      >
        <template #header>
          <div class="w-100">
            <b-row class="d-flex align-items-center">
              <b-col cols="5">
                <h4>{{ info.title }}</h4>
                <span class="alert px-50 alert-info">{{
                  info.meetingType.name_ar
                }}</span>
              </b-col>
              <b-col cols="5">
                <h4 class="d-flex align-items-center">
                  <feather-icon size="15" icon="CalendarIcon" class="mx-1" />{{
                    info.meeting_date
                  }}
                </h4>
              </b-col>
              <b-col cols="2">
                <router-link
                  :to="{ name: 'file-view', query: { ep: info.file } }"
                  target="_blank"
                  v-can="{ slug: $route.meta.slug, action: 'O' }"
                >
                  <b-button
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon size="18" icon="DownloadIcon" />
                  </b-button>
                </router-link>
                <b-button
                  v-can="{ slug: $route.meta.slug, action: 'U' }"
                  @click="$emit('editClicked', info)"
                  variant="flat-primary"
                  class="btn-icon rounded-circle"
                  v-if="canAddTransaction"
                >
                  <feather-icon size="15" icon="EditIcon" />
                </b-button>
                <b-button
                  v-can="{ slug: $route.meta.slug, action: 'D' }"
                  variant="flat-danger"
                  @click="onDeleteClicked()"
                  class="btn-icon rounded-circle"
                  v-if="canAddTransaction"
                >
                  <feather-icon size="15" icon="Trash2Icon" />
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
        <div>
          <h5 class="text-primary">اسماء الحضور</h5>
          <div v-html="info.attendance_names"></div>
        </div>
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { BButton, BCard, BModal, BRow, BCol } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    info: Object,
    page: Number,
  },
  components: {
    AppCollapse,
    AppCollapseItem,
    BButton,
    BCard,
    BModal,
    BRow,
    BCol,
  },
  computed:{
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),

  },
  methods: {
    onDeleteClicked() {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الاجتماع", {
          title: "تأكيد حذف الاجتماع",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$store
              .dispatch("AdministrativeStatus/meeting/deleteMeeting", {
                page: this.page,
                id: this.info.id,
              })
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تم الحذف بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                    timeout: 3000,
                  },
                });
              });
          }
        });
    },
  },
};
</script>
